"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.SuppliersReducer = undefined;

var _apiSupplier = require("../actions/esdb/apiSupplier");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuppliersReducer = exports.SuppliersReducer = function SuppliersReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var action = arguments[1];

	switch (action.type) {
		case "API_SUPPLIERS_SUCCESS":
			return _lodash2.default.merge({}, state, action.payload.data.SUPPLIERS.reduce(function (obj, item) {
				obj[item.SUPPLIER_ID] = {
					loading: action.payload.loading,
					error: action.payload.error,
					data: item
				};
				return obj;
			}, {}));
		case _apiSupplier.API_SUPPLIER_SUCCESS:
			return _lodash2.default.merge({}, state, Object.values(action.payload.data).reduce(function (obj, item) {
				obj[item.SUPPLIER_ID] = {
					loading: action.payload.loading,
					error: action.payload.error,
					data: item
				};
				return obj;
			}, {}));
		default:
			return state;
	}
};

//TODO: einbauen (ehemenals im ProductReducer)

// case API_PRODUCTS_SUPPLIER_REQUEST:
// case API_PRODUCTS_SUPPLIER_SUCCESS:
// 	return _.merge({}, state, {
// 		suppliers: _.merge({}, {data: null, error: null, loading: null}, action.payload)
// 	});